<div class="erb">
  @if (isDownloading) {
    <svg class="erb__border-svg" viewBox="0 0 40 36" aria-hidden="true">
      <rect
        class="erb__border-path"
        x="0.75"
        y="0.75"
        width="38.5"
        height="34.5"
        rx="7.25"
      />
    </svg>
  }

  <button
    class="btn btn-sm erb__trigger"
    [class.erb__trigger--open]="isOpen"
    [class.erb__trigger--loading]="isDownloading"
    [class.erb__trigger--done]="isDone"
    [class.erb__trigger--error]="isError"
    [disabled]="isDownloading || isDone || isError"
    [ngbTooltip]="buttonTooltip"
    tooltipClass="custom-tooltip"
    placement="bottom"
    (click)="togglePanel()"
  >
    @if (!isDownloading && !isDone && !isError) {
      <i class="fa-solid fa-download"></i>
    }

    @if (isDownloading) {
      <span class="erb__liquid" [style.height.%]="progress">
        <i class="fa-solid fa-clover erb__clover erb__clover--1"></i>
        <i class="fa-solid fa-clover erb__clover erb__clover--2"></i>
        <i class="fa-solid fa-clover erb__clover erb__clover--3"></i>
        <i class="fa-solid fa-clover erb__clover erb__clover--4"></i>
      </span>
      <span class="erb__pct"
        >{{ progress | number: '1.0-0' }}<small>%</small></span
      >
    }

    @if (isDone) {
      <i class="fa-solid fa-check erb__icon-done"></i>
    }

    @if (isError) {
      <i class="fa-solid fa-xmark erb__icon-error"></i>
    }
  </button>

  @if (isOpen) {
    <div class="erb__panel">
      <div class="erb__scope-row">
        <span class="erb__scope-label">
          {{
            (hasFilters
              ? 'ExportReportButton.Panel.OnlyFiltered'
              : 'ExportReportButton.Panel.AllRecords'
            ) | translate
          }}
        </span>
        <button
          class="erb__switch"
          [class.erb__switch--on]="isAll"
          (click)="isAll = !isAll"
          role="switch"
          [attr.aria-checked]="isAll"
        >
          <span class="erb__switch-thumb"></span>
        </button>
      </div>

      <div class="erb__divider"></div>

      <button class="erb__dl-row" (click)="downloadFormat('xlsx')">
        <i class="fa-solid fa-file-excel"></i>
        <span class="erb__dl-name">{{
          'ExportReportButton.Panel.DownloadXlsx' | translate
        }}</span>
        <span class="erb__dl-scope">· {{ scopeSuffix }}</span>
      </button>
      <button class="erb__dl-row" (click)="downloadFormat('csv')">
        <i class="fa-solid fa-file-csv"></i>
        <span class="erb__dl-name">{{
          'ExportReportButton.Panel.DownloadCsv' | translate
        }}</span>
        <span class="erb__dl-scope">· {{ scopeSuffix }}</span>
      </button>
    </div>
  }
</div>
